import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useFeatureFlags } from './useFeatureFlags'

/**
 * Route-level gate. Renders nothing while flags are resolving, then redirects
 * if the feature is off for this organization.
 *
 * Courtesy, not control: the API refuses the same requests via the backend
 * FeatureGuard. This exists so a customer never sees a page that would only
 * return 403s — not to keep them out.
 */
export function RequireFeature({
  flag,
  children,
  redirectTo = '/dashboard',
}: {
  flag: string
  children: ReactNode
  redirectTo?: string
}): React.ReactElement | null {
  const { flags, isLoading } = useFeatureFlags()
  if (isLoading) return null
  if (flags[flag] !== true) return <Navigate to={redirectTo} replace />
  return <>{children}</>
}
